module.exports = __webpack_public_path__ + "img/2-6.8e806adb.png";